import { PropertyData } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

type AddCompsPayload =
  | PropertyData[]
  | {
      comps: PropertyData[];
      sequenceTarget: 'compSequence' | 'rentalCompSequence';
    };

export const addComps = createAction('addComps', (payload: AddCompsPayload) => ({
  payload: Array.isArray(payload)
    ? { comps: payload, sequenceTarget: 'compSequence' as const }
    : payload,
}));
